import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginApi, LoginRequest } from "../../api";
import tufinLogo from '../../assets/tufin.png';
import styles from './Login.module.css';

const Login: React.FC = () => {
    const [userId, setUserId] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        const abortController = new AbortController();

        const loginRequest: LoginRequest = {
            user_id: userId,
        };

        try {
            const response = await loginApi(loginRequest, abortController.signal);
            const data = await response.json();

            if (data.success) {
                const timestamp = new Date().getTime();
                const userData = { ...loginRequest, timestamp, agree_to_terms: data.agree_to_terms};
                if (data.agree_to_terms) {
                    // User has signed the document, redirect to the dashboard
                    localStorage.setItem('user', JSON.stringify(userData));
                    navigate('/home');
                } else {
                    // User hasn't signed the document, redirect to the legal document page
                    localStorage.setItem('user', JSON.stringify(userData));
                    navigate('/legal-document');
                }
            } else {
                setErrorMessage('Wrong access code. Please check your code and try again.');
                localStorage.removeItem('user'); // Clear local storage on failed login
            }
        } catch (error) {
            if (error instanceof DOMException && error.name === 'AbortError') {
                console.log('Request was aborted');
            } else {
                setErrorMessage('An unexpected error occurred. Please try again later.');
                localStorage.removeItem('user'); // Clear local storage on failed login
            }
        }
    };

    return (
        <div className={styles.loginContainer}>
            <div className={styles.loginBox}>
                {/* Tufin Logo */}
                <img
                    src={tufinLogo}
                    alt="Tufin Logo"
                    style={{width: '80px', height: '80px', marginBottom: '0px'}}
                />
                <h2 className={styles.loginTitle}>Welcome to TufinMate</h2>
                <h3 className={styles.subTitle}>for NetSec Engineers</h3>
                <form onSubmit={handleSubmit}>
                    <div className={styles.inputGroup}>
                        <label htmlFor="userId">Please enter your access code</label>
                        <input
                            type="text"
                            id="userId"
                            value={userId}
                            onChange={(e) => setUserId(e.target.value)}
                            required
                        />
                    </div>
                    {errorMessage && <div className={styles.error}>{errorMessage}</div>}
                    <button type="submit" className={styles.loginButton}>Login</button>
                </form>
            </div>
        </div>
    );
};

export default Login;
